






import { defineComponent } from '@vue/composition-api';

/**
 * ## コンテナ
 *
 * モーダルのヘッダーを除くボディ部分に適用させるコンテナ。
 * 共通の余白を持ち、プログレスバーをトップに固定する。
 *
 */
export default defineComponent({
  name: 'AppContainer',
  props: {
    hasProgress: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return {
      className: [
        'AppContainer',
        {
          'has-progress': props.hasProgress,
        },
      ],
    };
  },
});
